import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { white, boxShadowRaised } from "@churchofjesuschrist/eden-style-constants";
const Container = styled.header.withConfig({
  componentId: "sc-17z1fiy-0"
})(["grid-area:header;background:", ";box-shadow:", ";z-index:3;"], white, boxShadowRaised);

const Header = _ref => {
  let {
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement(Container, props, children);
};

Header.propTypes = {
  /** Content to render in the header */
  children: PropTypes.node.isRequired
};
export default Header;